/*@flow*/
import client from 'store/apollo';
import gql from 'graphql-tag';
import type { DocumentNode } from 'graphql';
import GetAlertSubscriptions from '../queries/GetAlertSubscriptions';
import type { DestroyAlertSubscription_destroyAlertSubscription } from './__generated__/DestroyAlertSubscription';

export default {
  commit: (props: {
    districtId: ID,
    id: ID,
  }): Promise<?DestroyAlertSubscription_destroyAlertSubscription> =>
    client
      .mutate({
        mutation: gql`
          mutation DestroyAlertSubscription($id: ID!) {
            destroyAlertSubscription(input: { id: $id }) {
              success
              errors
            }
          }
        `,
        variables: props,
        refetchQueries: [
          {
            query: GetAlertSubscriptions,
            variables: { districtId: props.districtId },
          },
        ],
      })
      .then(res => res.data && res.data.destroyAlertSubscription),
};
